module.exports = __webpack_public_path__ + "static/media/cores.f4634a95.png";